import { configureStore } from '@reduxjs/toolkit';
import { reducers } from '../reducers/reducer';
import { accountAPI } from '../../entities/user/account/api/api';
import { authAPI } from '../../entities/user/auth/api/api';
import { apis } from '../../shared/api/apis';
import websocketMiddleware from '../../features/websocket/model/webSocketMiddleware';
import Utils from '../../shared/libs/Editor/utils/impl/Utils';

const apisData = apis.map(el => el.middleware);
const URL = Utils.Backend.getSocketConnectionString();

const setupStore = () => configureStore({
	reducer: reducers,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({
		serializableCheck: false,
	}).concat(accountAPI.middleware, authAPI.middleware, websocketMiddleware, ...apisData),
});

const store = setupStore();

export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']

export default store;
